import {css} from '@emotion/css';
import {Breakpoints, mq} from '../../../../../styles/js/mixins/media-queries';
import {colours, fonts, spacing, elementSize} from '../../../../../styles/js/variables';

const styles = {
  sidebar: css`
    label: sidebar;
    font-weight: ${fonts.weight.SEMI_BOLD};
  `,
  sidebarInner: css`
    label: sidebar__inner;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    ${mq(Breakpoints.TABLET)} {
      flex-direction: row;
    }
    ${mq(Breakpoints.DESKTOP)} {
      flex-direction: column;
      justify-content: flex-start;
      max-width: calc((${elementSize.container.LG} / 12) * 3);
      max-height: auto;
    }
  `,
  advantages: css`
    label: sidebar__advantages;
    margin-bottom: ${spacing.L};
    font-size: ${fonts.size.XL};
    line-height: ${fonts.lineHeight.BASE};
    list-style-type: none;
    li {
      margin-bottom: ${spacing.S};
      svg {
        /* stylelint-disable sh-waqar/declaration-use-variable */
        margin-right: 0.6rem;
        margin-bottom: -0.4rem;
        margin-left: -3.2rem;
        /* stylelint-enable sh-waqar/declaration-use-variable */

        path {
          fill: ${colours.semantic.SUCCESS};
        }
      }
    }
  `,
  trustpilot: css`
    label: sidebar__trustpilot;
    padding-top: ${spacing.XS};
    ${mq(Breakpoints.DESKTOP)} {
      padding-top: 0;
    }
  `,
  bottom: css`
    label: sidebar__bottom;
    display: none;
    ${mq(Breakpoints.TABLET)} {
      display: block;
      padding-top: ${spacing.L};
    }
  `,
};

export default styles;
